module.exports = __webpack_public_path__ + "img/p28.bbbc8294.gif";